/**
 * Saturation point for a heat tint over a set of signed percentage moves: the
 * 80th-percentile magnitude (nearest-rank), floored at 1. One runaway position
 * (a +190% since-entry gain) must not flatten every ordinary move to a whisper;
 * values beyond the scale saturate at full strength instead.
 */
export const HEAT_PERCENTILE = 0.8

export function heatScale(values: ReadonlyArray<number | null | undefined>): number {
  const mags = values
    .filter((v): v is number => typeof v === 'number' && Number.isFinite(v))
    .map(Math.abs)
    .sort((a, b) => a - b)
  if (mags.length === 0) return 1
  const rank = Math.max(1, Math.ceil(HEAT_PERCENTILE * mags.length))
  return Math.max(1, mags[rank - 1])
}
